import { withInstall } from '@mts-fe/utils';
import _MButton from './src/MButton.vue';
import popConfirmButton from './src/PopConfirmButton.vue';

export type { MButtonProps } from './src/props';

export const MButton = withInstall(_MButton);
export const PopConfirmButton = withInstall(popConfirmButton);
